module.exports = __webpack_public_path__ + "img/tpc-21.ee9755bd.webp";